import { useRegionContext } from 'common/contexts/RegionContext';
import { getPage } from 'constants/pages';
import { matchPath, useLocation } from 'react-router-dom';

/**
 * Returns the region information based on the path
 * @returns the region, or USLA if unable to determine
 */
export const useRegion = () => {
  const { region } = useRegionContext();
  return region;
};

/**
 * Helper hook for determining if a page is regional- i.e. the path includes a region param
 */
export const useIsRegional = () => {
  const location = useLocation();
  const page = getPage(location.pathname);
  const params = page && matchPath(page.path, location.pathname)?.params;
  return (params && !!params.region) || false;
};
